import { render, staticRenderFns } from "./ToolbarSlider.vue?vue&type=template&id=af50b0ca&"
import script from "./ToolbarSlider.vue?vue&type=script&lang=js&"
export * from "./ToolbarSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports